import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./featuredInfo.css";
import { useCurrency } from "../../currency/currencyContext";

export default function FeaturedInfo() {
  const [totalOrders, setTotalOrders] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalStocksValue, setTotalStocksValue] = useState(0);
  const [totalSales, setTotalSales] = useState(0);

  const navigate = useNavigate();
  const { formatPrice, getCurrencySymbol, convertPrice, getCurrentCurrency } = useCurrency(); // Add currency context

  useEffect(() => {
    // Fetch orders
    axios
      .get("https://backend.hira-tech.co.uk/order/getAllorder/")
      .then((response) => {
        setTotalOrders(response.data.length);

        // Calculate total sales
        const salesSum = response.data.reduce(
          (sum, order) => sum + (order.subtotal || 0),
          0
        );
        setTotalSales(salesSum);
      })
      .catch((error) =>
        console.error("There was an error fetching the orders!", error)
      );

    // Fetch products
    axios
      .get("https://backend.hira-tech.co.uk/product/getAllproduct/")
      .then((response) => {
        setTotalProducts(response.data.length);

        // Calculate stock value
        const stockValueSum = response.data.reduce(
          (sum, product) => {
            if (product.product_Stock > 0) {
              return sum + (product.product_Price * product.product_Stock || 0);
            }
            return sum;
          },
          0
        );
        setTotalStocksValue(stockValueSum);
      })
      .catch((error) =>
        console.error("There was an error fetching the products!", error)
      );
  }, []);

  return (
    <div className="featured">
      {/* Orders Box */}
      <div
        className="featuredItem ordersBox"
        onClick={() => navigate("/admin/orders")}
        style={{ cursor: "pointer" }}
      >
        <span className="featuredTitle">Total Orders</span>
        <div className="featuredMoneyContainer">
          <span className="featuredMoney">{totalOrders}</span>
        </div>
      </div>

      {/* Sales Box */}
      <div
        className="featuredItem salesBox"
        onClick={() => navigate("/admin/monthly-invoices")}
        style={{ cursor: "pointer" }}
      >
        <span className="featuredTitle">Total Sales</span>
        <div className="featuredMoneyContainer">
          <span className="featuredMoney">{formatPrice(totalSales)}</span>
        </div>
      </div>

      {/* Products + Stocks Box */}
      <div
        className="featuredItem productsBox"
        onClick={() => navigate("/admin/products")}
        style={{ cursor: "pointer" }}
      >
        <div className="featuredMoneyContainer doubleBox">
          <div className="innerBox">
            <span className="featuredTitle">Total Products</span>
            <div className="featuredMoney">{totalProducts}</div>
          </div>
          <div className="innerBox">
            <span className="featuredTitle">Total Stock Value</span>
            <div className="featuredMoney">{formatPrice(totalStocksValue)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}